import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '4 - 2x3',
  imageCount: 4,
  displayGroup: 'DG_WALLET',
  calc: (height) => {
    const pWidth = height / ASPECT_RATIO / 2;
    const pHeight = height / 2;

    return {
      gridTemplate: `
        'p1 p2 p3 p4' ${pHeight}px
        '. . . .' ${pHeight}px
        / ${pWidth}px ${pWidth}px ${pWidth}px ${pWidth}px`,
      photos: gridPhotos(1, 4, pWidth, pHeight)
    };
  }
};
